import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { DelegationService } from 'app/modules/vehicle-inventory/services/table-management/delegation.service';
import { VehicleAssignmentsService } from 'app/modules/vehicle-inventory/services/vehicle-assignments.service';
import { BillingaccountService } from 'app/rest/billingaccount.service';
import { CecoService } from 'app/rest/ceco.service';
import { Rest } from 'app/rest/rest_client';
import { SubdelegationService } from 'app/rest/subdelegation.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { NotificationsService } from 'app/services/notifications-service/notifications.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-vehicle-assignments-form',
  templateUrl: './vehicle-assignments-form.component.html',
  styleUrls: ['./vehicle-assignments-form.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VehicleAssignmentsFormComponent extends EntityFormComponent<Rest.InvVehicleAssignment>
implements OnInit {

  @Input() entities: Rest.InvVehicleAssignment[] = [];
noticeChannels: SelectItem[];
channelsList: Rest.NoticeChannel[];
title: string;

billingAccountList: Rest.BillingAccount[] = [];
billingAccountRequestContext: any;
delegationList: Rest.Delegation[] = [];
delegationRequestContext: any;
subDelegationList: Rest.Subdelegation[] = [];
subDelegationRequestContext: any;
cecoList: Rest.Ceco[] = [];
cecoRequestContext: any;

startDate: Date;
endDate: Date;

canUpdate: boolean;
minStartDate: Date
maxStartDate: Date;



constructor(
  private vehicleAssignmentsService: VehicleAssignmentsService,
  notificationsService: NotificationsService,
  protected i18n: I18nService,
  private authenticationService: AuthenticationService,
  public translateService: TranslateService,
  private billingAccountService: BillingaccountService,
  private delegationService: DelegationService,
  private subdelegationService: SubdelegationService,
  private cecoService: CecoService,
  protected userTime: UserTimePipe,

) {
  super(vehicleAssignmentsService, notificationsService, i18n, authenticationService);
}

/**
 * Loads and evaluates all the necessary data before showing the form.
 *
 * @memberof AccessoryFormComponent
 */
ngOnInit(): void {
  this.setPermissions();
  
}

setPermissions() {
  const user = this.authenticationService.user;

  this.canUpdate = this.authenticationService.isRoleGranted('INV_VEHICLE_ASSIGNMENTS_UPDATE', user);
  }

beforeShow() {

  this.title = this.translateService.instant('vehicleAssignments.header');

  this.billingAccountRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    loadPermissions: false,
    filters: {},
  } as Rest.ListPaginationRequest;
  
  if(this.entity.company){
    this.billingAccountRequestContext.filters['fullName'] = [this.entity.company.code + " " + this.entity.company.name];
    this.billingAccountRequestContext.filters['clientID'] = [this.entity.client.id.toString()];
  }

  this.billingAccountService.getPage(this.billingAccountRequestContext).then((p) => {
    this.billingAccountList = p.entities.map((billingAccount) => ({
      ...billingAccount,
      fullName: `(${billingAccount.code}) ${billingAccount.name}`,
    }));
  });

  this.delegationRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    loadPermissions: false,
    filters: {},
  } as Rest.ListPaginationRequest;

  if(this.entity.delegation){
    this.delegationRequestContext.filters['fullName'] = [this.entity.delegation.code + " " + this.entity.delegation.name];
  }

  this.delegationService.getPage(this.delegationRequestContext).then((p) => {
    this.delegationList = p.entities.map((delegation) => ({
      ...delegation,
      fullName: `(${delegation.code}) ${delegation.name}`,
    }));
  });

  this.subDelegationRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    loadPermissions: false,
    filters: {},
  } as Rest.ListPaginationRequest;

  if(this.entity.subDelegation){
    this.subDelegationRequestContext.filters['fullName'] = [this.entity.subDelegation.code + " " + this.entity.subDelegation.name];
  }

  this.subdelegationService.getPage(this.subDelegationRequestContext).then((p) => {
    this.subDelegationList = p.entities.map((subDelegation) => ({
      ...subDelegation,
      fullName: `(${subDelegation.code}) ${subDelegation.name}`,
    }));
  });


  this.cecoRequestContext = {
    sortBy: 'code',
    sortAsc: true,
    pageSize: 10,
    loadPermissions: false,
    filters: {},
  } as Rest.ListPaginationRequest;

  if(this.entity.ceco){
    this.cecoRequestContext.filters['fullName'] = [this.entity.ceco.code + " " + this.entity.ceco.description];
  }

  this.cecoService.getPage(this.cecoRequestContext).then((p) => {
    this.cecoList = p.entities.map((ceco) => ({
      ...ceco,
      fullName: `(${ceco.code}) ${ceco.description}`,
    }));
  });

  this.startDate = this.entity.startDate ? this.userTime.utcToCalendarDate(this.entity.startDate) : null;
  this.endDate = this.entity.endDate ? this.userTime.utcToCalendarDate(this.entity.endDate) : null;

  var firstVehicleAssignment = this.entities[0];

  if(firstVehicleAssignment.id == this.entity.id) {
      if(this.entities.length > 1){
        this.minStartDate = this.entities[1].startDate;
        this.maxStartDate = null;
      }else{
        this.minStartDate = null;
        this.maxStartDate = null;
      }
  }else{
      this.minStartDate = null;
      this.maxStartDate = this.entities[0].startDate;
  }
}

onFilterBillingAccount(event) {
  this.billingAccountRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.billingAccountService.getPage(this.billingAccountRequestContext).then((p) => {
    this.billingAccountList = p.entities.map((billingAccount) => ({
      ...billingAccount,
      fullName: `(${billingAccount.code}) ${billingAccount.name}`,
    }));
  });
}

onChangeBillingAccount(event){
  this.entity.company = event.value;
  this.entity.ceco = null;

  this.cecoRequestContext.filters['billingAccount'] = [this.entity.company.id.toString()];
  this.cecoService.getPage(this.cecoRequestContext).then((p) => {
    this.cecoList = p.entities.map((ceco) => ({
      ...ceco,
      fullName: `(${ceco.code}) ${ceco.description}`,
    }));
  });
}

onFilterDelegation(event) {
  this.delegationRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.delegationService.getPage(this.delegationRequestContext).then((p) => {
    this.delegationList = p.entities.map((delegation) => ({
      ...delegation,
      fullName: `(${delegation.code}) ${delegation.name}`,
    }));
  });
}

onChangeDelegation(event) {
  this.entity.delegation = event.value;
  this.entity.subDelegation = null;
  this.subDelegationRequestContext.filters['delegation'] = [this.entity.delegation.name.toString()];
  this.subdelegationService.getPage(this.subDelegationRequestContext).then((p) => {
    this.subDelegationList = p.entities.map((subDelegation) => ({
      ...subDelegation,
      fullName: `(${subDelegation.code}) ${subDelegation.name}`,
    }));
  });
}

onFilterSubDelegation(event) {
  this.subDelegationRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.subdelegationService.getPage(this.subDelegationRequestContext).then((p) => {
    this.subDelegationList = p.entities.map((subDelegation) => ({
      ...subDelegation,
      fullName: `(${subDelegation.code}) ${subDelegation.name}`,
    }));
  });
}

onChangeSubDelegation(event) {
  this.entity.subDelegation = event.value;
}

onFilterCeco(event) {
  this.cecoRequestContext.filters['fullName'] = [event.filter ?? ''];
  this.cecoService.getPage(this.cecoRequestContext).then((p) => {
    this.cecoList = p.entities.map((ceco) => ({
      ...ceco,
      fullName: `(${ceco.code}) ${ceco.description}`,
    })) ;
  });
}

onChangeCeco(event) {
  this.entity.ceco = event.value;
}

protected beforeSave(): void {
  this.entity.startDate = this.startDate;
  this.entity.endDate = this.endDate;

  if(this.entity.ceco){
    delete this.entity.ceco.fullName;
  }

  if(this.entity.company){
    delete this.entity.company.fullName;
  }

  if(this.entity.delegation){
    delete this.entity.delegation.fullName;
  }

  if(this.entity.subDelegation){
    delete this.entity.subDelegation.fullName;
  }
  
}

}


